import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ZoneMasterDto {
  id?: number;
  zoneName: string;
  isActive: boolean;
}
export interface ZoneMaster extends ZoneMasterDto {
  id: number;
}

/** GetAll/GetById return PascalCase (Dapper dynamic) — map to the camelCase UI model. */
function mapZone(x: any): ZoneMaster {
  return {
    id: x.Id ?? x.id,
    zoneName: x.ZoneName ?? x.zoneName ?? '',
    isActive: (x.IsActive ?? x.isActive) ?? true,
  };
}

function mapEnvelope(res: any) {
  if (Array.isArray(res?.data)) return { ...res, data: res.data.map(mapZone) };
  if (res?.data && typeof res.data === 'object') return { ...res, data: mapZone(res.data) };
  if (Array.isArray(res)) return res.map(mapZone);
  return res;
}

@Injectable({ providedIn: 'root' })
export class ZoneMasterService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/ZoneMaster`;

  getAll() {
    return this.http.get(`${this.baseUrl}/GetAll`).pipe(map(mapEnvelope));
  }
  insert(dto: ZoneMasterDto) {
    return this.http.post(`${this.baseUrl}/Insert`, dto);
  }
  update(dto: ZoneMasterDto) {
    return this.http.post(`${this.baseUrl}/Update`, dto);
  }
  setActive(id: number, isActive: boolean) {
    return this.http.get(`${this.baseUrl}/SetActive`, { params: { id, isActive } });
  }
  delete(id: number) {
    return this.http.get(`${this.baseUrl}/Delete`, { params: { id } });
  }
}
